import * as React from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/index.css'

const componentMapping = {
  'hunt-achievements-card': () => import('../models/hunt-achievements/views/hunt-achievements-chart-view'),
  'react-test': () => import('../components/react-test'),
  'subscription-dashboard-card-view': () => import('../models/subscription/views/subscription-dashboard-card-view'),
  'user-scheduled-hunts-dashboard-card-view': () => import('../models/user-scheduled-hunts/views/user-scheduled-hunts-dashboard-card-view'),
  'user-scheduled-hunts-dashboard-view': () => import('../models/user-scheduled-hunts/views/user-scheduled-hunts-dashboard-view'),
  'concierge-dashboard-card-view': () => import('../models/tenant/views/concierge-dashboard-card-view'),
  'changelog-view': () => import('../models/cms/views/changelog-view'),
  'changelog-version-view': () => import('../models/cms/views/changelog-version-view'),
  'notes-dashboard': () => import('../models/notes/views/notes-dashboard-view'),
  'commission-calculator-view': () => import('../models/commissions/views/commission-calculator-view'),
  'commission-report-view': () => import('../models/commissions/views/commission-report-view'),
  'commission-overrides-view': () => import('../models/commission-overrides/views/commission-overrides-view'),
  'out-of-date-hunts': () => import('../models/out-of-date-hunts/views/out-of-date-hunts-view'),
  'out-of-date-courses': () => import('../models/out-of-date-courses/views/out-of-date-courses-view'),
  'listing-changes-view': () => import('../models/listing-changes/views/listing-changes-view'),
  'dashboard-navbar': () => import('../models/app/views/dashboard-navbar-view'),
  'user-state-applications-view': () => import('../models/user-state-applications/views/user-state-applications-view'),
  'admin-permissions-dashboard': () => import('../models/admin-tools/views/permissions-dashboard-view'),
  'user-state-species-points-cms': () => import('../models/user-state-species-points/views/user-state-species-points-cms-view'),
  'user-state-species-points-profile': () => import('../models/user-state-species-points/views/user-state-species-points-profile-view'),
  'external-state-site-mappings-cms': () => import('../models/external-state-site-mappings/views/external-state-site-mappings-cms-view'),
  'hunt-eligibility-cms': () => import('../models/hunt-eligibility/views/hunt-eligibility-cms-view'),
  'global-toaster': () => import('../models/app/components/global-toaster'),
} as const

const rootMap = new Map()
let hasInitialized = false

async function initializeReactComponents() {
  // Prevent double initialization on initial page load
  if (hasInitialized && !document.documentElement.hasAttribute('data-turbolinks-preview')) {
    return
  }
  hasInitialized = true

  // Unmount any existing roots first to prevent conflicts
  rootMap.forEach((root) => {
    root.unmount()
  })
  rootMap.clear()

  // Find all React component mount points
  const mountPoints = document.querySelectorAll('[data-react-component]')
  
  for (const mountPoint of mountPoints) {
    const componentName = mountPoint.getAttribute('data-react-component') as keyof typeof componentMapping

    if (componentName && componentMapping[componentName]) {
      try {
        const { default: Component } = await componentMapping[componentName]()
        const root = createRoot(mountPoint as Element)
        rootMap.set(mountPoint, root)
        root.render(React.createElement(Component))
      }
      catch (error) {
        console.error(`Failed to load component: ${componentName}`, error)
      }
    }
  }
}

// Only use turbolinks:load which fires on initial load and navigation
document.addEventListener('turbolinks:load', initializeReactComponents)

// Reset flag on turbolinks navigation away
document.addEventListener('turbolinks:before-cache', () => {
  hasInitialized = false
})
